import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=8390473c&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=8390473c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8390473c",
  null
  
)

export default component.exports